import "../../design/pricing.css";
import { CheckCircle, XCircle } from "lucide-react";

const tiers = [
    {
        name: "Economy",
        highlight: false,
        services: {
            "Page Counts": "1 Page",
            "Design & UI": false,
            "OAuth Integration": false,
            "Auth System": false,
            "Admin Panel": false,
            "Cybersecurity": false,
            "Support": false,
        },
        price: "~1,800"
    },
    {
        name: "Premium",
        highlight: true,
        services: {
            "Page Counts": "2 - 5 Pages",
            "Design & UI": true,
            "OAuth Integration": false,
            "Auth System": true,
            "Admin Panel": false,
            "Cybersecurity": false,
            "Support": "1 Year Warranty"
        },
        price: "~7,000",
    },
    {
        name: "Enterprise",
        highlight: false,
        services: {
            "Page Counts": "5+ Custom Pages",
            "Design & UI": true,
            "OAuth Integration": true,
            "Auth System": true,
            "Admin Panel": true,
            "Cybersecurity": true,
            "Support": "1 - 3 Years"
        },
        price: "Custom Quote"
    }
];

export default function Pricing() {
    const changeUrlByDivID = (link) => {
        document.getElementById(link)?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <section id="pricing" className="pricingSection">
            <div className="cyberSectionHeader">
                <span className="sectionTag">TRANSACTIONS</span>
                <h2>DEVELOPMENT <span className="gradientText">TIERS</span></h2>
            </div>

            <div className="pricingCardsContainer">
                {tiers.map((tier, index) => (
                    <div
                        key={index}
                        className={`pricingCard glass-panel ${tier.highlight ? "highlightedTier" : ""}`}
                    >
                        {tier.highlight && <div className="popularTag">RECOMMENDED</div>}

                        <h3 className="tierTitle">{tier.name}</h3>

                        <div className="tierPrice">
                            <span className="amount">{tier.price}</span>
                            {tier.price.includes("~") && <span className="currency"> ₾</span>}
                        </div>

                        <div className="tierFeatures">
                            {Object.entries(tier.services).map(([service, value], idx) => (
                                <div key={idx} className="featureRow">
                                    <span className="featureLabel">{service}</span>
                                    <div className="featureVal">
                                        {typeof value === "boolean" ? (
                                            value ? (
                                                <CheckCircle size={16} className="iconCheck" />
                                            ) : (
                                                <XCircle size={16} className="iconCross" />
                                            )
                                        ) : (
                                            <span className="badgeValue">{value}</span>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <button
                            className={`pricingButton ${tier.highlight ? "highlightBtn" : ""}`}
                            onClick={() => changeUrlByDivID('contact')}
                        >
                            SELECT TIER
                        </button>
                    </div>
                ))}
            </div>
        </section>
    );
}